export * from 'src/app/core/loading/loading.service';
export * from 'src/app/core/loading/loading.module';
